import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../ui/layout";
import Breadcrumb from "../../ui/breadcrumb";
import TabBar from "../../ui/tab-bar";
import ErrorPage from "../../ui/error";
import Pending from "./pending";
import Reconciled from "./reconciled";
import errorBlue from "../../../assets/img/error-blue.png";
import "./css/index.scss";
import Automatic from "./automatic";
import { AUTOMATIC } from "../../../state/actions";
import generateAction from "../../../utils/action-helpers";
import { usePageView, fireEvent } from "../../../utils/google-analytics-handler";

const Reconciliation = () => {
  usePageView("/conciliation");
  const dispatch = useDispatch();
  const {
    user: {
      current: { email, role }
    },
    pending: { error: pendingError },
    conciliated: { error: conciliatedError },
    automatic: { tabIndex }
  } = useSelector(state => state);
  const pages = [{ name: "Conciliaciones", path: "/", active: true }];
  if (role === "Admin") pages.push({ name: "Administración", path: "/admin", active: false });
  const tabs = useMemo(
    () => [
      { title: "Pendientes", body: <Pending /> },
      { title: "Prevalidadas", body: <Automatic /> },
      { title: "Conciliadas", body: <Reconciled /> }
    ],
    []
  );
  if (pendingError || conciliatedError)
    return (
      <ErrorPage
        title="Error en conciliaciones"
        subtitle="Oopps. Ha habido un error obteniendo las conciliaciones"
        text="Recargue la página y si el error persiste contacte con el CSU"
        image={errorBlue}
        email={email}
        role={role}
        pages={pages}
      />
    );
  const onTabChange = newIndex => {
    let action = "PENDIENTES";
    if (newIndex === 1) {
      action = "PREVALIDADAS";
    } else if (newIndex === 2) {
      action = "CONCILIADAS";
    }
    fireEvent("RecontiliacionsTableView", action);
    dispatch(generateAction(AUTOMATIC.SET_TAB_INDEX, newIndex));
  };
  return (
    <Layout email={email} role={role} pages={pages}>
      <Breadcrumb
        elements={[
          { name: "CPA", active: false },
          { name: "Conciliaciones", active: true, action: () => {} }
        ]}
      />

      <h2>Transferencias recibidas hoy</h2>
      <div className="card">
        <div className="card-body">
          <TabBar index={tabIndex} onTabIndexChange={onTabChange} tabs={tabs} />
        </div>
      </div>
    </Layout>
  );
};

export default Reconciliation;
